import { render, staticRenderFns } from "./Concept.vue?vue&type=template&id=486b0c5a&scoped=true&"
import script from "./Concept.vue?vue&type=script&lang=js&"
export * from "./Concept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486b0c5a",
  null
  
)

export default component.exports